import { contractsCompleteSigning } from "@/orval/gen"
import { Center } from "@mantine/core"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/app/contracts/approvals/$contractId/signed"
)({
  validateSearch: (search: { workflowId: number; event: string }) => search,
  loaderDeps: ({ search: { workflowId, event } }) => ({ workflowId, event }),
  loader: async ({ deps: { workflowId, event }, params: { contractId } }) => {
    if (workflowId !== undefined && event === "signing_complete") {
      await contractsCompleteSigning({
        contractId: parseInt(contractId),
        workflowId: workflowId,
      })
    }
    throw redirect({ to: ".." })
  },
  pendingComponent: PendingComponent,
})

function PendingComponent() {
  return <Center h={"100%"}>Signing finalization...</Center>
}
